<template>
  <wizard-base
    class="inherited"
    :title="$t('WIZARD.GENERAL_QUESTIONS.TITLE')"
    :content-column-classes="['is-8', 'is-6-desktop']"
  >
    <div class="general-questions__question">
      <h3 class="general-questions__question__title">
        {{ $t(`WIZARD.GENERAL_QUESTIONS.QUESTIONS.INHERITANCE`) }}
      </h3>
      <TileSelectWithReset
        v-model="inheritance"
        :items="yesNoOptions"
        name="hasInheritance"
        type="string"
        class="general-questions__question__options"
      />
    </div>
    <div v-if="shouldShowInheritanceDocumentQuestion" class="general-questions__question">
      <h3 class="general-questions__question__title">
        {{ $t(`WIZARD.GENERAL_QUESTIONS.QUESTIONS.INHERITANCE_DOCUMENT`) }}
      </h3>
      <TileSelectWithReset
        v-model="inheritanceDocument"
        :items="yesNoOptions"
        name="hasInheritanceDocument"
        type="string"
        class="general-questions__question__options"
      />
    </div>
    <div class="general-questions__question">
      <h3 class="general-questions__question__title">
        {{ $t(`WIZARD.GENERAL_QUESTIONS.QUESTIONS.LEASEHOLD`) }}
      </h3>
      <TileSelectWithReset
        v-model="leasehold"
        :items="yesNoOptions"
        name="hasLeasehold"
        type="string"
        class="general-questions__question__options"
      />
    </div>
    <div v-if="shouldShowLeaseholdContractQuestion" class="general-questions__question">
      <h3 class="general-questions__question__title">
        {{ $t(`WIZARD.GENERAL_QUESTIONS.QUESTIONS.LEASEHOLD_CONTRACT`) }}
      </h3>
      <TileSelectWithReset
        v-model="leaseholdContract"
        :items="yesNoOptions"
        name="hasLeaseholdContract"
        type="string"
        class="general-questions__question__options"
      />
    </div>
  </wizard-base>
</template>

<script>
// Components
import WizardBase from '@/layout/WizardBase.vue';
import TileSelectWithReset from '@/components/TileSelectWithReset.vue';
// Services
import { mapFeatures } from '@/services/feature';
// Constants
import { MUTATION } from '@/store/CONSTANTS';

export default {
  name: 'OwnershipStructureSlide',
  components: {
    WizardBase,
    TileSelectWithReset,
  },
  data() {
    return {
      yesNoOptions: [
        {
          text: this.$t('WIZARD.GENERAL_QUESTIONS.OPTION.YES'),
          value: true,
        },
        {
          text: this.$t('WIZARD.GENERAL_QUESTIONS.OPTION.NO'),
          value: false,
        },
        {
          text: this.$t('WIZARD.GENERAL_QUESTIONS.OPTION.DONT_KNOW'),
          value: 'dont_know', // will be converted to null before sending the evaluation
        },
      ],
    };
  },
  computed: {
    ...mapFeatures(['inheritance', 'inheritanceDocument', 'leasehold', 'leaseholdContract']),
    shouldShowInheritanceDocumentQuestion() {
      return this.inheritance === true;
    },
    shouldShowLeaseholdContractQuestion() {
      return this.leasehold === true;
    },
  },
  watch: {
    shouldShowInheritanceDocumentQuestion(shouldShow) {
      if (!shouldShow) {
        this.$store.commit(MUTATION.WIZARD.CURRENT_DEAL.SET_FEATURE_VALUE, {
          name: 'inheritanceDocument',
          value: undefined,
        });
      }
    },
    shouldShowLeaseholdContractQuestion(shouldShow) {
      if (!shouldShow) {
        this.$store.commit(MUTATION.WIZARD.CURRENT_DEAL.SET_FEATURE_VALUE, {
          name: 'leaseholdContract',
          value: undefined,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/mixins.scss';
.general-questions {
  &__question {
    margin-bottom: 1.5rem;
    &__title {
      margin-bottom: 1rem;
    }
  }
}
</style>
